module.exports = __webpack_public_path__ + "img/product-superiority.d20e8d0f.png";